import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { ValidationErrors } from "@angular/forms";
import { ValidationMessageProvider } from "../validation-message-provider";

@Component({
    selector: "validation-messages",
    templateUrl: "./validation-messages.component.html",
    standalone: false
})
export class ValidationMessagesComponent implements OnChanges {
  @Input() errors: ValidationErrors;

  messages: string[];

  constructor(private validationMessageProvider: ValidationMessageProvider) {
    this.messages = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    const errors = this.validationMessageProvider.getValidationErrors(
      this.errors
    );

    // this.messages = [].concat(errors);
    this.messages.splice(0, this.messages.length, ...errors);
  }
}
